import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'
import { Detail } from './Detail'

export function SettleConfig() {

    return (
        <>
            <PageHeader />
            <DataBox />
            <Detail />
        </>
    )
}
